<template>
    <div>
        <div class="cardLanding">
            <vs-row class="pt-3">
                <vs-col w="12" class="mb-3 d-flex">
                    <vs-button
                        border
                        @click="scrollMeTo('porto', 'historial')"
                    >
                        Ver historial
                    </vs-button>
                </vs-col>
                <vs-col sm="12" lg="5">
                    <form autocomplete="off">
                        <label class="labelInput">
                            Institución
                        </label>
                        <vs-select class="aqui pt-0" :loading="loadingInstitucion" filter :key="institucionId" v-model="institutoHijo" :disabled="!instituciones.length" @input="getCiclo()">
                            <template v-if="instituciones.length">
                                <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" :value="0">
                                    No hay datos
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="5">
                    <form autocomplete="off">
                        <label class="labelInput">
                            Ciclo Escolar
                        </label>
                        <vs-select class="mr-0 pt-0" :loading="loadingCiclo" filter v-model="cicloEscolarHijo"  :key="cicloEscolarId" :disabled="!cicloEscolares.length" @input="getPrograma()">
                            <template v-if="cicloEscolares.length">
                                <vs-option v-for="option in cicloEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" :value="0">
                                    No hay datos
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="2" style="margin-bottom: 0; margin-top: 22px;">
                    <vs-button
                        class="table-search-button mb-0"
                        @click="getRefreshAll()"
                    >
                    <i class="fas fa-search" style="margin-right: 10px"></i>Buscar
                    </vs-button>
                </vs-col>
            </vs-row>
            <vs-row class="mt-4">
                <vs-col>
                    <h6 class="mayusculas">
                        <strong>Procesos generales</strong>
                    </h6>
                    <div style="justify-content: space-between; display: flex;">
                        <div>
                            <md-menu md-size="small" md-align-trigger :md-offset-x="-70">
                                <vs-button
                                    class="m-auto"
                                    color="warn"
                                    md-menu-trigger
                                >
                                Cargos<i class="fas fa-sort-down" style="margin-left: 10px;"></i>
                                </vs-button>

                                <md-menu-content>
                                    <md-menu-item v-if="permisos.includes('generar-cargos-gestion')" @click="getModal('generar');">Generar cargos</md-menu-item>
                                    
                                    <md-menu-item :disabled="cargo == true" v-if="permisos.includes('reestablecer-cargos-gestion')" @click="getModal('reestablecer');" >Reestablecer cargos</md-menu-item>
                                    <!-- <md-menu-item @click="getModal('contracargos');" >Eliminar contracargos</md-menu-item> -->
                                    <md-menu-item v-if="permisos.includes('generar-cargos-gestion')" @click="getModal('obligatorio');">Servicios opcional a obligatorio</md-menu-item>
                                </md-menu-content>
                            </md-menu>
                        </div>
                        <div>
                            <md-menu md-size="small" md-align-trigger>
                                <vs-button
                                    class="m-auto"
                                    color="primary"
                                    md-menu-trigger
                                >
                                Becas<i class="fas fa-sort-down" style="margin-left: 10px;"></i>
                                </vs-button>

                                <md-menu-content>
                                    <md-menu-item v-if="permisos.includes('aplicar-becas-gestion')" @click="getModal('aplicar-beca')">Aplicar</md-menu-item>
                                    <md-menu-item v-if="permisos.includes('desaplicar-beca-gestion')" @click="getModal('desaplicar-beca')" >Desaplicar</md-menu-item>
                                </md-menu-content>
                            </md-menu>
                        </div>
                        <div>
                            <!-- <vs-button
                                color="danger"
                                md-menu-trigger
                                @click="activeTransladar =! activeTransladar"
                            >
                                Transladar saldos
                            </vs-button> -->
                            <md-menu md-size="small" md-align-trigger>
                                <vs-button
                                    class="m-auto"
                                    color="danger"
                                    md-menu-trigger
                                >
                                Saldos<i class="fas fa-sort-down" style="margin-left: 10px;"></i>
                                </vs-button>

                                <md-menu-content>
                                    <md-menu-item v-if="permisos.includes('aplicar-pagos-gestion')" @click="getModal('actualizar-saldos')">Actualizar</md-menu-item>
                                    <!-- <md-menu-item @click="activeTransladar =! activeTransladar">Trasladar</md-menu-item> -->
                                    <!-- <md-menu-item v-if="permisos.includes('reestablecer-saldos-gestion')" @click="getModal('reestablecer-saldos')">Reestablecer</md-menu-item> -->
                                </md-menu-content>
                            </md-menu>
                        </div>
                        <div>
                            <md-menu
                                md-size="medium"
                                md-align-trigger
                            >
                                <vs-button
                                    color="#45B39D"
                                    md-menu-trigger
                                >
                                <i class="fas fa-download" style="margin-right: 10px;"></i>Registrar pago<i class="fas fa-sort-down" style="margin-left: 10px;"></i>
                                </vs-button>
                                

                                <md-menu-content>
                                    <md-menu-item v-if="tienePermisos('registrar-pago-abierto-gestion')" @click="openModalRegistrarPago('abierto')" class="hoverList"><span class="fontMedium">Pago abierto</span></md-menu-item>
                                    <md-menu-item disabled v-if="tienePermisos('registrar-pago-regla-gestion')" @click="openModalRegistrarPago('cargo-abono')"  class="hoverList"><span class="fontMedium">Pago desde regla de cobro</span></md-menu-item>
                                    <md-menu-item v-if="tienePermisos('registrar-pago-servicio-gestion')" @click="openModalRegistrarPago('servicio')"  class="hoverList"><span class="fontMedium">Pago desde servicio</span></md-menu-item>
                                </md-menu-content>
                            </md-menu>
                        </div>
                        <div>
                            <vs-button
                                color="#9D30EC"
                                md-menu-trigger
                                @click="getModal('desaplicar-parcialidad')"
                            >
                                Desaplicar parcialidad
                            </vs-button>
                        </div>
                    </div>
                    <div  style="display: flex;">
                        <div>
                            <vs-button
                                success
                                flat
                                md-menu-trigger
                                @click="scrollMeTo('porto', 'conciliacion')"
                            >
                                Historico de conciliación de Banamex
                            </vs-button>
                        </div>
                        <div>
                            <vs-button
                                v-if="tienePermisos('referencia-pago-anticipo')"
                                color="#2471A3"
                                md-menu-trigger
                                @click="activePagoAbierto =! activePagoAbierto"
                            >
                                Generación de referencia de pago abierto
                            </vs-button>
                        </div>
                    </div>
                    <div style="display: flex;">
                        <!-- <div>
                            <vs-button
                                flat
                                md-menu-trigger
                            >
                                Archivos de banco
                            </vs-button>
                        </div> -->
                    </div>
                </vs-col>
            </vs-row>
            <vs-row class="mt-4">
                <vs-col w="12">
                    <balance :institucionNivel="institucionNivel" :programa="programa" :programas="programas" :programaId="programaId" :permisos="permisos" :institucion="institutoHijo" :cicloEscolar="cicloEscolarHijo" :personaId="personaId" :nivel="nivel" :ejecutarAcciones="ejecutar" @refreshTable="getRefreshAll" @ejecutarLoading="getLoading" :ciclosEscolares="cicloEscolares" :ejecutarBalance="ejecutarBalance" :personaRol="personaRol"></balance>
                </vs-col>
            </vs-row>
            <vs-dialog prevent-close v-model="activeModal">
                <template #header>
                <h4 class="not-margin">
                    {{infoModal.titulo}}
                </h4>
                </template>


                <div class="con-form text-center">
                    <h5 v-if="infoModal.tipo != 'obligatorio'">¿Esta seguro de {{infoModal.cuerpo}}?</h5>
                    <div v-if="infoModal.tipo == 'obligatorio'">
                        <label class="mb-2">Seleccione el servicio opcional a convertirlo en obligatorio</label>
                        <vs-select class="aqui pt-0 pl-0" placeholder="Selecione un servicio opcional" filter :key="serviciosOpcId" v-model="servicioOpc" :disabled="!serviciosOpc.length">
                            <template v-if="serviciosOpc.length">
                                <vs-option v-for="option in serviciosOpc" :key="option.id"  :label="option.concepto" :value="option.id">
                                    {{option.concepto}} - {{option.monto | currency}} {{option.subcategoria_servicio != '' ? '(' + option.subcategoria_servicio + ')' : ''}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" :value="0">
                                    No hay datos
                                </vs-option>
                            </template>
                        </vs-select>
                    </div>
                </div>

                <template #footer>
                    <div class="footer-dialog d-flex justify-content-between">
                        <div>
                            <vs-button
                                danger
                                border
                                @click="activeModal = false"
                            >
                                Cancelar
                            </vs-button>
                        </div>
                        <div>
                            <vs-button
                                success
                                @click="getAcciones(infoModal.tipo)"
                            >
                                Aceptar
                            </vs-button>
                        </div>
                    </div>
                </template>
            </vs-dialog>
            <modal-registrar-pago v-model="activeRegPago" :persona-id="personaId" :ciclo-escolar="cicloEscolarHijo" :tipo="tipoRegistro" :institucion="institutoHijo" :programa="programa" :programas="programas" :programaId="programaId" :cicloEscolares="cicloEscolares"  @refreshTable="getEjecutar"></modal-registrar-pago>
            <modal-mover-saldo v-model="activeTransladar" :cicloEscolares="cicloEscolares"></modal-mover-saldo>
            <registro-pago-abierto v-model="activePagoAbierto" :persona-id="personaId" :ciclo-escolar="cicloEscolarHijo" :tipo="tipoRegistro" :institucion="institutoHijo" :programa="programa" :programas="programas" :programaId="programaId" ></registro-pago-abierto>
        </div>
    </div>
</template>

<script>
import balance from './tabla-balance.vue'
import ModalRegistrarPago from './modales/registrar-pagos'
import RegistroPagoAbierto from './modales/registrar-pagos-abierto.vue'
import ModalMoverSaldo from './modales/mover-saldo.vue'
import profesor from '../../../api/requests/landing-profesor'
import Historial from './historial.vue'
export default {
    props:[
        'personaId',
        'parametros',
        'institucion',
        'instituciones',
        'institucionId',
        'cicloEscolar',
        'cicloEscolares',
        'cicloEscolarId',
        'nivel',
        'programa',
        'programaId',
        'programas',
        'permisos',
        'cargo',
        'refrescar',
        'institucionNivel',
        'loadingCiclo',
        'loadingInstitucion',
        'ejecutarBalance',
        'personaRol'
    ],
    data: ()=>({
        tipoRegistro: '',
        activeRegPago: false,
        activeModal: false,
        activeTransladar: false,
        infoModal: [],
        tipoRegistro: '',
        ejecutar: 0,
        institutoHijo: '',
        cicloEscolarHijo:'',
        activeHistorial: false,
        servicioOpc: '',
        serviciosOpc: [],
        serviciosOpcId: (new Date()).getTime(),
        activePagoAbierto: false
    }),
    components:{
        balance,
        ModalRegistrarPago,
        ModalMoverSaldo,
        Historial,
        RegistroPagoAbierto
    },
    methods:{
        async getServiciosOpcionales(){
            if(this.cicloEscolar){
                try{
                    let params = {
                        page: this.page || 1,
                        size: '100',
                        id: this.personaId,
                        institucion: this.institucion,
                        ciclo_escolar: this.cicloEscolar,
                        tipo_servicio: 'opcional'
                    }
                    const { data: response } = await profesor.getCargosNoObligatorios(params)
                    this.serviciosOpc = response.data
                }catch(error){
                    console.log(error)
                }
            }
        },
        getInfo(){
            this.institutoHijo = this.institucion
            this.cicloEscolarHijo = this.cicloEscolar
        },
        getCiclo(){
            this.$emit('refreshCiclo', this.institutoHijo)
        },
        getPrograma(){
            this.$emit('refreshPrograma', this.cicloEscolarHijo)
        },
        getRefreshAll(){
            this.$emit('refrescarParametros', this.cicloEscolarHijo);
            this.getServiciosOpcionales()
        },
        scrollMeTo(refName, boton) {
            this.$emit('scrollTable', refName, boton)
        },
        openModalRegistrarPago ( tipo ){
            this.tipoRegistro = tipo
            this.activeRegPago = !this.activeRegPago
        },
        getModal(tipo){
            this.activeModal =! this.activeModal
            if(tipo == 'generar'){
                this.infoModal = {
                    'titulo': 'Generar Cargos',
                    'cuerpo': 'generar cargos',
                    'tipo': tipo,
                }
            }
            if(tipo == 'reestablecer'){
                this.infoModal = {
                    'titulo': 'Reestablecer cargos',
                    'cuerpo': 'reestablecer cargos',
                    'tipo': tipo
                }
            }
            if(tipo == 'contracargos'){
                this.infoModal = {
                    'titulo': 'Eliminar contracargos',
                    'cuerpo': 'eliminar contracargos',
                    'tipo': tipo
                }
            }
            if(tipo == 'aplicar-beca'){
                this.infoModal = {
                    'titulo': 'Aplicar beca',
                    'cuerpo': 'aplicar beca',
                    'tipo': tipo
                }
            }
            if(tipo == 'desaplicar-beca'){
                this.infoModal = {
                    'titulo': 'Desaplicar beca',
                    'cuerpo': 'desaplicar beca',
                    'tipo': tipo
                }
            }
            if(tipo == 'desaplicar-parcialidad'){
                this.infoModal = {
                    'titulo': 'Desaplicar parcialidad',
                    'cuerpo': 'desaplicar parcialidad',
                    'tipo': tipo
                }
            }
            if(tipo == 'actualizar-saldos'){
                this.infoModal = {
                    'titulo': 'Actualizar saldos',
                    'cuerpo': 'actualizar saldos',
                    'tipo': tipo
                }
            }
            if(tipo == 'reestablecer-saldos'){
                this.infoModal = {
                    'titulo': 'Reestablecer saldos',
                    'cuerpo': 'reestablecer saldos',
                    'tipo': tipo
                }
            }
            if(tipo == 'obligatorio'){
                this.infoModal = {
                    'titulo': 'Servicio opcional a obligatorio',
                    'cuerpo': 'hacer servicio opcional a obligatorio',
                    'tipo': tipo
                }
            }
            
        },
        getAcciones(tipo){
            if(tipo == 'generar'){
                this.postGenerarCargos()
            }
            if(tipo == 'reestablecer'){
                this.getRestablecerCargos()
            }
            if(tipo == 'aplicar-beca'){
                this.postAplicarBecas()
            }
            if(tipo == 'desaplicar-beca'){
                this.postDesaplicarBecas()
            }
            if(tipo == 'desaplicar-parcialidad'){
                this.postDesaplicarParcialidad()
            }
            if(tipo == 'actualizar-saldos'){
                this.postAplicarPagos()
            }
            if(tipo == 'reestablecer-saldos'){
                this.postReestablecerSaldos()
            }
            if(tipo == 'obligatorio'){
                this.getServicioOpcionalaObligatorio()
            }
        },
        async getServicioOpcionalaObligatorio(){
            const loading = this.$vs.loading()
            try {
                const params = {
                    persona_id: this.personaId,
                    institucion_id: this.institucion,
                    ciclo_escolar: this.cicloEscolar,
                    regla_cobro_id: this.servicioOpc
                }
                const response = await profesor.getServicioOpcionalaObligatorio(params)
                this.activeModal = false
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Operación éxitosa'
                })
                this.ejecutar += 1
            }catch(error){
                loading.close()
                console.log(error)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Algo salió mal',
                    text: 'Favor de comunicarse con el administrador'
                })
            }
        },
        async postGenerarCargos () {
            if(this.nivel[1]){
                this.activeAcciones = !this.activeAcciones
            }else{
                const loading = this.$vs.loading()
                let formData = new FormData();
                formData.append("id", this.personaId),
                formData.append("ciclo_escolar", this.cicloEscolarHijo),
                formData.append("institucion", this.institutoHijo),
                formData.append("programa", this.programa)
                formData.append("nivel_academico", this.nivel)
                const vm = this
                    try {
                        const response = await profesor.getGenerarCargos(formData)
                        if(response.data.response[0].status === 200){
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'success',
                                position: null,
                                title: 'Operación éxitosa'
                            })
                            loading.close()
                            this.ejecutar += 1
                        }else {
                            if (response.data && response.data.response[0] && response.data.response[0].message){
                                this.$vs.notification({
                                    progress: 'auto',
                                    color: 'danger',
                                    position: null,
                                    title: 'Error',
                                    text: response.data.response[0].message
                                })
                            }
                            loading.close()
                        }
                        this.activeModal = false
                    } catch (error) {
                        this.activeModal = false
                       if (error.response.data && error.response.data.errores){
                            const data = error.response.data.errores
                            if (data.descripcion){
                                this.$vs.notification({
                                    progress: 'auto',
                                    color: 'danger',
                                    position: null,
                                    title: 'Error',
                                    text: data.descripcion
                                })
                            }
                        }else{
                            this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: `Algo salió mal`
                            })
                        }
                        loading.close()
                    }
            }
        },
        async getRestablecerCargos  () {
            if(this.nivel[1]){
                this.activeAcciones = !this.activeAcciones
            }else{
                const loading = this.$vs.loading()
                let formData = new FormData();
                formData.append("id", this.personaId),
                formData.append("ciclo_escolar", this.cicloEscolarHijo),
                formData.append("institucion", this.institutoHijo),
                formData.append("programa", this.programa)
                formData.append("nivel_academico", this.nivel)
                const vm = this
                    try {
                        const response = await profesor.getRestablecerCargos (formData)
                        if(response.data.response[0].status === 200){
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'success',
                                position: null,
                                title: 'Operación éxitosa'
                            })
                            loading.close()
                            this.ejecutar += 1
                        }else {
                            if (response.data && response.data.response[0] && response.data.response[0].message){
                                this.$vs.notification({
                                    progress: 'auto',
                                    color: 'danger',
                                    position: null,
                                    title: 'Error',
                                    text: response.data.response[0].message
                                })
                            }
                            loading.close()
                        }
                        this.activeModal = false
                    } catch (error) {
                        this.activeModal = false
                       if (error.response.data && error.response.data.errores){
                            const data = error.response.data.errores
                            if (data.descripcion){
                                this.$vs.notification({
                                    progress: 'auto',
                                    color: 'danger',
                                    position: null,
                                    title: 'Error',
                                    text: data.descripcion
                                })
                            }
                        }else{
                            this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: `Algo salió mal`
                            })
                        }
                        loading.close()
                    }
            }
        },
        async postAplicarBecas () {
            if(this.nivel[1]){
                this.activeAcciones = !this.activeAcciones
            }else{
                const loading = this.$vs.loading()
                let formData = new FormData();
                formData.append("id", this.personaId),
                formData.append("ciclo_escolar", this.cicloEscolarHijo),
                formData.append("institucion", this.institutoHijo),
                formData.append("programa", this.programa)
                formData.append("nivel_academico", this.nivel)
                const vm = this
                    try {
                        const response = await profesor.postAplicarBecas(formData)
                        if(response.data.response[0].status === 200){
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'success',
                                position: null,
                                title: 'Operación éxitosa'
                            })
                            loading.close()
                            this.ejecutar += 1
                        }else {
                            if (response.data && response.data.response[0] && response.data.response[0].message){
                                this.$vs.notification({
                                    progress: 'auto',
                                    color: 'danger',
                                    position: null,
                                    title: 'Error',
                                    text: response.data.response[0].message
                                })
                            }
                            loading.close()
                        }
                        this.activeModal = false
                    } catch (error) {
                        this.activeModal = false
                       if (error.response.data && error.response.data.errores){
                            const data = error.response.data.errores
                            if (data.descripcion){
                                this.$vs.notification({
                                    progress: 'auto',
                                    color: 'danger',
                                    position: null,
                                    title: 'Error',
                                    text: data.descripcion
                                })
                            }
                        }else{
                            this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: `Algo salió mal`
                            })
                        }
                        loading.close()
                    }
            }
        },
        async postDesaplicarBecas () {
            if(this.nivel[1]){
                this.activeAcciones = !this.activeAcciones
            }else{
                const loading = this.$vs.loading()
                let formData = new FormData();
                formData.append("id", this.personaId),
                formData.append("ciclo_escolar", this.cicloEscolarHijo),
                formData.append("institucion", this.institutoHijo),
                formData.append("programa", this.programa)
                formData.append("nivel_academico", this.nivel)
                const vm = this
                    try {
                        const response = await profesor.postDesaplicarBecas(formData)
                        if(response.data.response[0].status === 200){
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'success',
                                position: null,
                                title: 'Operación éxitosa'
                            })
                            loading.close()
                            this.ejecutar += 1
                        }else {
                            if (response.data && response.data.response[0] && response.data.response[0].message){
                                this.$vs.notification({
                                    progress: 'auto',
                                    color: 'danger',
                                    position: null,
                                    title: 'Error',
                                    text: response.data.response[0].message
                                })
                            }
                            loading.close()
                        }
                        this.activeModal = false
                    } catch (error) {
                        this.activeModal = false
                       if (error.response.data && error.response.data.errores){
                            const data = error.response.data.errores
                            if (data.descripcion){
                                this.$vs.notification({
                                    progress: 'auto',
                                    color: 'danger',
                                    position: null,
                                    title: 'Error',
                                    text: data.descripcion
                                })
                            }
                        }else{
                            this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: `Algo salió mal`
                            })
                        }
                        loading.close()
                    }
            }
        },
        async postDesaplicarParcialidad () {
            const loading = this.$vs.loading()
            let formData = new FormData();
            formData.append("id", this.personaId),
            formData.append("ciclo_escolar", this.cicloEscolarHijo),
            formData.append("institucion", this.institutoHijo),
            formData.append("programa", this.programa)
            formData.append("nivel_academico", this.nivel)
            const vm = this
                try {
                    const response = await profesor.postDesaplicarParcialidad(formData)
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'success',
                            position: null,
                            title: 'Operación éxitosa'
                        })
                        loading.close()
                            this.ejecutar += 1
                        this.activeModal = false
                } catch (error) {
                        this.activeModal = false
                    if (error.response.data && error.response.data.errores){
                        const data = error.response.data.errores
                        if (data.descripcion){
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'danger',
                                position: null,
                                title: 'Error',
                                text: data.descripcion
                            })
                        }
                    }else{
                        this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Error',
                        text: `Algo salió mal`
                        })
                    }
                    loading.close()
                }
        },
        async postAplicarPagos () {
            if(this.nivel[1]){
                this.activeAcciones = !this.activeAcciones
            }else{
                const loading = this.$vs.loading()
                let formData = new FormData();
                formData.append("id", this.personaId),
                formData.append("ciclo_escolar", this.cicloEscolarHijo),
                formData.append("institucion", this.institutoHijo),
                formData.append("programa", this.programa)
                formData.append("nivel_academico", this.nivel)
                const vm = this
                    try {
                        const response = await profesor.postAplicarPagos(formData)
                        if(response.data.response[0].status === 200){
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'success',
                                position: null,
                                title: 'Operación éxitosa'
                            })
                            loading.close()
                            this.ejecutar += 1
                        }else {
                            if (response.data && response.data.response[0] && response.data.response[0].message){
                                this.$vs.notification({
                                    progress: 'auto',
                                    color: 'danger',
                                    position: null,
                                    title: 'Error',
                                    text: response.data.response[0].message
                                })
                            }
                            loading.close()
                        }
                        this.activeModal = false
                    } catch (error) {
                        this.activeModal = false
                       if (error.response.data && error.response.data.errores){
                            const data = error.response.data.errores
                            if (data.descripcion){
                                this.$vs.notification({
                                    progress: 'auto',
                                    color: 'danger',
                                    position: null,
                                    title: 'Error',
                                    text: data.descripcion
                                })
                            }
                        }else{
                            this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: `Algo salió mal`
                            })
                        }
                        loading.close()
                    }
            }
        },
        async postReestablecerSaldos () {
            if(this.nivel[1]){
                this.activeAcciones = !this.activeAcciones
            }else{
                const loading = this.$vs.loading()
                let formData = new FormData();
                formData.append("id", this.personaId),
                formData.append("ciclo_escolar", this.cicloEscolarHijo),
                formData.append("institucion", this.institutoHijo),
                formData.append("programa", this.programa)
                formData.append("nivel_academico", this.nivel)
                const vm = this
                    try {
                        const response = await profesor.postReestablecerSaldos(formData)
                        if(response.data.response[0].status === 200){
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'success',
                                position: null,
                                title: 'Operación éxitosa'
                            })
                            loading.close()
                            this.ejecutar += 1
                        }else {
                            if (response.data && response.data.response[0] && response.data.response[0].message){
                                this.$vs.notification({
                                    progress: 'auto',
                                    color: 'danger',
                                    position: null,
                                    title: 'Error',
                                    text: response.data.response[0].message
                                })
                            }
                            loading.close()
                        }
                        this.activeModal = false
                    } catch (error) {
                        this.activeModal = false
                       if (error.response.data && error.response.data.errores){
                            const data = error.response.data.errores
                            if (data.descripcion){
                                this.$vs.notification({
                                    progress: 'auto',
                                    color: 'danger',
                                    position: null,
                                    title: 'Error',
                                    text: data.descripcion
                                })
                            }
                        }else{
                            this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: `Algo salió mal`
                            })
                        }
                        loading.close()
                    }
            }
        },
        
        
        tienePermisos(permisos, requiredAll = false){
            let tienePermiso = false
            if (Array.isArray(this.permisos)){
                if (Array.isArray(permisos)){
                    const permisosEncontrados = this.permisos.filter(e => permisos.includes(e))
                    return requiredAll 
                        ? permisosEncontrados.length === permisos.length 
                        : Boolean(permisosEncontrados.length)
                } else if (String(permisos) !== '') {
                    return this.permisos.includes(String(permisos))
                }
            }
            return tienePermiso
        },
        getEjecutar(){
            this.ejecutar += 1
        },
        getLoading(estatus){
            this.$emit('ejecutarLoading', estatus);
        },
    },
    watch:{
        refrescar(){
            this.getEjecutar()
        },
        institucion(){
            this.getInfo()
        },
        cicloEscolar(){
            this.getInfo()
            this.getServiciosOpcionales()
            // this.$emit('refrescarParametros');
        },

    }
}
</script>


<style>
    .cardLanding{
        width: 95%;
        margin: auto;
        background: white;
    }
    .mayusculas{
        text-transform: uppercase;
    }
</style>